import React, { useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import './datatable.css';
import SearchIcon from '@mui/icons-material/Search';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa'; // Importing icons
const DataTable = ({ data, columns }) => {
  const [sortConfig, setSortConfig] = useState({ key: columns[0]?.key, direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const itemsPerPage = 10;
  const [formattedData, setFormattedData] = useState([]);
useEffect(() => {
  const newFormattedData = data.map((row) => {
    // Ensure booking_date exists and is a string before calling split
    if (row.booking_date && typeof row.booking_date === 'string') {
      const [datePart, timePart] = row.booking_date.split(' '); // Split the bookingDate into date and time
      const date = new Date(datePart); // Convert the date part to a Date object
      const monthName = date.toLocaleString('default', { month: 'short' }); // Get the month abbreviation (e.g., Jan, Feb)
      const formattedDate = `${date.getFullYear()}-${monthName}-${date.getDate()}`; // Format the date as YYYY-MMM-dd (e.g., 2024-Feb-24)
  
      // Combine date and time to create a full Date object for sorting
      const time = new Date(`1970-01-01T${timePart}`); // Use a fixed date to combine with time
      const bookingDateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()); // Combine both parts into one Date object
  
      // Format the time part (booking time) into 12-hour am/pm format in lowercase
      const formattedBookingTime = time.toLocaleTimeString('en-GB', { hour12: false });
  
      return {
        ...row,
        originalDate: bookingDateTime, // Store the full Date object for sorting
        formattedServicePrice: isNaN(row.service_price) || row.service_price === null || row.service_price === undefined
          ? '₹ 0.00'
          : `₹ ${Number(row.service_price).toFixed(2)}`, // Ensure service_price is a valid number
      };
    }
    // If booking_date is not valid, return the row as is
    return row;
  });
  
  // Sort data based on the originalDate (combined date and time) in descending order
  const sortedData = newFormattedData.sort((a, b) => b.originalDate - a.originalDate);
  console.log("Formatted Data:", sortedData); // Log to check data
  setFormattedData(sortedData);
}, [data]);

  
  

  // Sorting function (although we're primarily sorting by booking date now)
  const handleSort = (column) => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  const filteredData = formattedData.filter((row) => {
let matchesSearch = columns.some((col) =>
  row[col.key]?.toString().toLowerCase().includes(searchTerm.toLowerCase())
);
console.log(`Row Matches Search: ${matchesSearch}`);

  
    if (selectedMonth) {
      const rowMonth = row.formattedBookingDate.split('-')[1]; // Extract month abbreviation
      matchesSearch = matchesSearch && rowMonth === selectedMonth;
    }
  
    return matchesSearch;
  });
  

  // Paginate filtered data
  const paginateData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // PDF download
  const downloadPDF = () => {
    const doc = new jsPDF();
    const tableColumn = columns.map((col) => col.label);
    const tableRows = paginateData.map((row) =>
      columns.map((col) => row[col.key])
    );

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save('data-table.pdf');
  };

  // Excel download
  const downloadExcel = () => {
    const ws = XLSX.utils.json_to_sheet(paginateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'data-table.xlsx');
  };

  // Month options for the dropdown
  const months = [
    { value: '', label: 'All Months' },
    { value: 'Jan', label: 'January' },
    { value: 'Feb', label: 'February' },
    { value: 'Mar', label: 'March' },
    { value: 'Apr', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'Jun', label: 'June' },
    { value: 'Jul', label: 'July' },
    { value: 'Aug', label: 'August' },
    { value: 'Sep', label: 'September' },
    { value: 'Oct', label: 'October' },
    { value: 'Nov', label: 'November' },
    { value: 'Dec', label: 'December' },
  ];

  // Determine styles based on the status
  const getStatusStyle = (status) => {
    switch (status) {
      case 'Pending':
        return { color: 'red' }; // Red for Pending
      case 'Confirmed':
        return { color: 'green' }; // Blue for Confirmed
      case 'Scheduled':
        return { color: 'orange' }; // Orange for Scheduled
      case 'Cancelled':
        return { color: 'brown' }; // Gray for Cancelled
      default:
        return {}; // No specific color
    }
  };

  return (
    <div className="data-table">
      <div className="actions-container">
        <div className="search-bar">
          <div className="search-input-container">
          <input
  type="text"
  className="search-input"
  placeholder="Search..."
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  style={{ border: '2px solid lightblue' }}
/>


            <SearchIcon className="search-icon" />
          </div>
        </div>
        <div className="table-actions">
          <button className="download-btn"   style={{
                    width:'150px',
                    backgroundColor: 'red',
                    height:'40px',
                    color: 'white',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                }} onClick={downloadPDF}><span style={{ fontSize: '15px' }}> Download </span> <FaFilePdf style={{ fontSize: '15px' }} /> {/* PDF Icon */}</button>
          <button className="download-btn"            style={{
                    width:'150px',
                    backgroundColor: 'green',
                    height:'40px',
                    color: 'white',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                }} onClick={downloadExcel}>             Download   <FaFileExcel style={{ fontSize: '15px' }} /> {/* Excel Icon */}</button>
        </div>
      </div>

      {/* Booking Date Filter by Month */}
      <div className="month-filter">
        <label htmlFor="month">Filter by Month: </label>
        <select
          id="month"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          {months.map((month) => (
            <option key={month.value} value={month.value}>
              {month.label}
            </option>
          ))}
        </select>
      </div>

      <table className="custom-table">
        <thead>
          <tr>
            {columns.map((col) => (
   <th
   key={col.key}
   onClick={() => handleSort(col.key)}
   style={{
     textAlign: 'center', 
     cursor: 'pointer',  
     padding: '10px',     
     fontWeight: 'bold',   
     fontSize: '16px', 
   }}
 >
   {col.label} 
   {sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '↓' : '↑') : ''}
 </th>
 
            ))}
          </tr>
        </thead>
        <tbody>
          {paginateData.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="no-providers-message">
                No data available.
              </td>
            </tr>
          ) : (
            paginateData.map((row, index) => (
              <tr key={index}>
                {columns.map((col) => (
                  <td
                    key={col.key}
                    style={{
                      textAlign: 'center',
                      fontWeight: col.key === 'booking_code' ? 'bold' : 'normal',
                      ... (col.key === 'status' ? getStatusStyle(row[col.key]) : {}),
                    }}
                  >
                    {col.key === 'service_price' ? row.formattedServicePrice : 
                     col.key === 'booking_code' ? <b>{row[col.key]}</b> : 
                     (typeof row[col.key] === 'string' ? row[col.key].charAt(0).toUpperCase() + row[col.key].slice(1) : row[col.key])}
                    {col.key === 'booking_date' && (
                      <>
                        <div>{row.formattedBookingDate}</div>
                        <div>{row.formattedBookingTime}</div>
                      </>
                    )}
                  </td>
                  
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
  {/* Row Count Section */}
  <div className="row-count" style={{ flex: 1 }}>
    <span>Showing {paginateData.length} of {filteredData.length} entries</span>
  </div>

  {/* Page Count in the center */}
  <div className="page-count" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
    <span>Page {currentPage} of {totalPages}</span>
  </div>

  {/* Pagination Buttons */}
  <div className="custom-pagination" style={{ display: 'flex', alignItems: 'center' }}>
    <button
      className="pagination-btn first-btn"
      onClick={() => handlePageChange(1)}
      disabled={currentPage === 1}
      style={{
        padding: '8px 12px',
        margin: '0 5px',
        backgroundColor: '#28a745', // Green color for First
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
      }}
    >
      First
    </button>
    <button
      className="pagination-btn prev-btn"
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      style={{
        padding: '8px 12px',
        margin: '0 5px',
        backgroundColor: '#e74c3c', // Red color for Prev
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
      }}
    >
      Prev
    </button>
    <button
      className="pagination-btn next-btn"
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      style={{
        padding: '8px 12px',
        margin: '0 5px',
        backgroundColor: '#3498db', // Blue color for Next
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
      }}
    >
      Next
    </button>
    <button
      className="pagination-btn last-btn"
      onClick={() => handlePageChange(totalPages)}
      disabled={currentPage === totalPages}
      style={{
        padding: '8px 12px',
        margin: '0 5px',
        backgroundColor: '#f39c12', // Yellow color for Last
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
      }}
    >
      Last
    </button>
  </div>
</div>

    </div>
  );
};

export default DataTable;
